import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { keyBy, get } from 'lodash';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import helpers from 'utils/helpers';
import currency from 'utils/currency';
import { CardButton, TransactionCardActionButton } from 'components/Styled';
import ImagePlane from 'assets/images/plane-black.svg';
import ImageEdit from 'assets/images/business/edit.svg';
import ImageRedo from 'assets/images/redo.svg';
import countries from 'data/countries';
import { getReschedulePickupRequest } from '../../../ducks/users';
import ReschedulePopup from './ReschedulePickup/ReschedulePopup';

const tags = {
  cancel: {
    color: '#cccccc'
  },
  hold: {
    color: '#cccccc'
  },
  complete: {
    color: '#57D7DD'
  },
  return: {
    color: '#ed3535'
  },
  'shipment-returned': {
    color: '#ed3535'
  },
  pending: {
    color: '#f09d78'
  },
  'first-mile-info-received': {
    color: '#2082c0'
  },
  'first-mile-delivered': {
    color: '#f0dd74'
  },
  'info-received': {
    color: '#f09d78'
  },
  'in-transit': {
    color: '#2082c0'
  },
  'out-for-delivery': {
    color: '#f0dd74'
  },
  'attempt-fail': {
    color: '#ba2ddb'
  },
  delivered: {
    color: '#57D7DD'
  },
  exception: {
    color: '#f92f37'
  },
  expired: {
    color: '#2C2C2E'
  },
  'parcel-scanned': {
    color: '#2082c0'
  }
};

const TRANSACTION_SUCCESS = 1;
const TRANSACTION_CANCEL = -1;
const TRANSACTION_COMPLETE = 2;
const TRANSACTION_HOLD = 4;
const TRANSACTION_RETURN = 5;
const PICKUP_NORMAL = 'NORMAL';

class TransactionCard extends Component {
  state = {
    showPopup: false
  };

  handleClick = () => {
    const transaction = this.props.transaction;
    this.props.history.push(
      `${process.env.PUBLIC_URL}/account/orders/${transaction.ref}`
    );
  };

  handleRescheduleClick = () => {
    window.dataLayer.push({
      event: 'Click Reschedule Pick Up Button'
    });

    const transaction = this.props.transaction;

    this.props.getReschedulePickupRequest({
      ref: transaction.ref
    });

    if (this.props.error === undefined && this.props.loading === false) {
      this.setState({ showPopup: true });
    }
  };

  handleAdjustmentClick = () => {
    const transaction = this.props.transaction;

    this.props.history.push(
      `${process.env.PUBLIC_URL}/account/orders/adjustment/${transaction.ref}`
    );
  };

  handleClose = () => this.setState({ showPopup: false });

  renderActionButton = () => {
    const transaction = this.props.transaction;
    const pickup = transaction.pickup;

    if (
      get(transaction, 'status') === TRANSACTION_SUCCESS &&
      get(pickup, 'type') === PICKUP_NORMAL
    ) {
      return (
        <TransactionCardActionButton
          className="theme-button"
          ghost
          onClick={this.handleRescheduleClick}>
          <div style={{ color: '#9900A5' }}>
            <img
              src={ImageEdit}
              style={{
                width: '12px',
                height: '12px',
                margin: '-1px 6px 2px 0px'
              }}
              alt=""
            />

            <span
              style={{
                fontSize: '12px',
                fontWeight: 700
              }}>
              {`${this.props.t('reschedule_pickup.title')} `}
            </span>
          </div>
        </TransactionCardActionButton>
      );
    } else if (get(transaction, 'status') === TRANSACTION_HOLD) {
      return (
        <TransactionCardActionButton
          className="theme-button"
          ghost
          onClick={this.handleAdjustmentClick}>
          <div style={{ color: '#9900A5' }}>
            <img
              src={ImageRedo}
              style={{
                width: '12px',
                height: '12px',
                margin: '-1px 6px 2px 0px'
              }}
              alt=""
            />

            <span
              style={{
                fontSize: '12px',
                fontWeight: 700
              }}>
              {`${this.props.t('confirmAdjustment.title')} `}
            </span>
          </div>
        </TransactionCardActionButton>
      );
    } else {
      return null;
    }
  };

  renderReschedulePopup = () => {
    if (this.state.showPopup && this.props.canReschedule !== undefined) {
      if (this.props.canReschedule) {
        return (
          <ReschedulePopup
            isBefore={true}
            t={this.props.t}
            transactionRef={this.props.transaction.ref}
            timeDate={this.props.timeDate}
            action={this.handleClose}
          />
        );
      } else {
        return (
          <ReschedulePopup
            isBefore={false}
            t={this.props.t}
            transactionRef={this.props.transaction.ref}
            action={this.handleClose}
          />
        );
      }
    } else {
      return null;
    }
  };

  render() {
    const countriesData = keyBy(this.props.countries, 'alpha-2');

    const lineHeight = '19.2px';
    const height = '58px';
    const marginBottom = '6px';

    let transaction = { ...this.props.transaction };
    transaction.finalTotal = new currency(transaction?.finalTotal);

    let transactionStatus;
    switch (get(transaction, 'status')) {
      case TRANSACTION_CANCEL:
        transactionStatus = 'cancel';
        break;
      case TRANSACTION_COMPLETE:
        transactionStatus = 'complete';
        break;
      case TRANSACTION_HOLD:
        transactionStatus = 'hold';
        break;
      case TRANSACTION_RETURN:
        transactionStatus = 'return';
        break;
      default:
        transactionStatus = 'success';
        break;
    }
    const shipment = transaction.shipments[0];
    // const discount = get(transaction, 'discount') || 0;

    return (
      <>
        <CardButton onClick={this.handleClick}>
          <Row type="flex" style={{ color: '#2C2C2E' }}>
            <Col style={{ flex: '1 1 auto' }}>
              <div>
                <div
                  style={{
                    fontSize: '16px',
                    fontWeight: 700,
                    paddingBottom: '4px'
                  }}>
                  {get(
                    countriesData[shipment.fromAddress.country],
                    `name.${this.props.t('key')}`
                  )}
                  <img
                    src={ImagePlane}
                    style={{
                      width: '31.3px',
                      paddingBottom: '4px',
                      margin: '0 6px'
                    }}
                    alt=""
                  />
                  {get(
                    countriesData[shipment.toAddress.country],
                    `name.${this.props.t('key')}`
                  )}
                </div>
              </div>

              <div
                style={{
                  lineHeight,
                  marginBottom,
                  height
                }}>
                {helpers.responsiveImage(
                  helpers.getCarrierImage(shipment.carrierService.carrier),
                  helpers.getCarrierText(shipment.carrierService.carrier),
                  helpers.getCarrierImageWidth(
                    shipment.carrierService.carrier,
                    0.8
                  )
                )}
                <span
                  style={{
                    fontSize: '12px',
                    paddingLeft: '8px',
                    color: '#2C2C2E'
                  }}>
                  {get(shipment.carrierService.name, this.props.t('key'))}
                </span>
              </div>

              <div>
                {`${this.props.t('finish.tracking_link')} `}
                <span style={{ fontSize: '12px', color: '#57D7DD' }}>
                  {shipment.trackingNumber}
                </span>
              </div>
            </Col>

            <Col style={{ textAlign: 'right', flex: '1 1 auto' }}>
              <div
                style={{
                  height: lineHeight,
                  lineHeight,
                  marginBottom
                }}>
                <div
                  style={{
                    fontSize: '16px',
                    fontWeight: 700,
                    paddingBottom: '4px',
                    lineHeight
                  }}>
                  {helpers.formatNumber(shipment.totalWeight, 1)}kg
                </div>

                <div
                  style={{
                    fontSize: '12px',
                    color: '#2C2C2E'
                  }}>
                  {this.props.t('payment.box', { amount: shipment.totalBox })}
                </div>
              </div>
            </Col>

            <Col span={7} style={{ textAlign: 'right', flex: '1 1 auto' }}>
              <div
                style={{
                  fontSize: '16px',
                  fontWeight: 700,
                  paddingBottom: '4px'
                }}>
                {transaction.finalTotal.format()}
              </div>

              <div
                style={{
                  fontSize: '12px',
                  color: '#2C2C2E',
                  lineHeight,
                  marginBottom
                }}>
                {moment(transaction.createdAt)
                  .format('MMM D YYYY')
                  .toUpperCase()}
              </div>
              {get(transaction, 'status') !== TRANSACTION_SUCCESS &&
              get(transaction, 'status') !== TRANSACTION_COMPLETE ? (
                <div>
                  <span style={{ fontSize: '10px', color: '#2C2C2E' }}>
                    <span
                      style={{
                        display: 'inline-block',
                        height: '10px',
                        width: '10px',
                        borderRadius: '99px',
                        backgroundColor: get(
                          tags,
                          `${transactionStatus}.color`
                        ),
                        marginRight: '12px'
                      }}></span>
                    {this.props.t(`transactions.tags.${transactionStatus}`)}
                  </span>
                </div>
              ) : (
                <>
                  {get(shipment, 'tracking.tag') ? (
                    <div>
                      <span style={{ fontSize: '10px', color: '#2C2C2E' }}>
                        <span
                          style={{
                            display: 'inline-block',
                            height: '10px',
                            width: '10px',
                            borderRadius: '99px',
                            backgroundColor: get(
                              tags[get(shipment, 'tracking.tag')],
                              'color'
                            ),
                            marginRight: '12px'
                          }}></span>
                        {this.props.t(
                          `transactions.tags.${get(shipment, 'tracking.tag')}`
                        )}
                      </span>
                    </div>
                  ) : null}
                </>
              )}
            </Col>
          </Row>
        </CardButton>
        {this.renderActionButton()}
        {this.renderReschedulePopup()}
      </>
    );
  }
}

const mapDispatchToProps = {
  getReschedulePickupRequest
};

const mapStateToProps = state => {
  return {
    countries: state.shipments.countries || countries,
    canReschedule: state.users.canReschedule,
    timeDate: state.users.timeDate,
    loading: state.users.loading,
    error: state.users.error
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TransactionCard));
